import React from 'react';
import styles from './WidgetFrame.module.css';

export const WidgetFrame: React.FC<WidgetFrameProps> = ({ children }) => <div className={styles.frame}>{children}</div>;

interface WidgetFrameProps {}
